<template>
  <footer class="main-footer">
    <div class="pull-right hidden-xs">
      <b>Version</b> 1.0
    </div>
    Hisana Admin &copy; 2018
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>




// WEBPACK FOOTER //
// Footer.vue?424c38c4